import { Subscription } from 'rxjs';
import { EvsRecord } from './evsRecord';

export interface ICancelAsync {
  subscription: Subscription | null;
  cancel: boolean;
}

export class CancelAsync extends EvsRecord implements ICancelAsync {
  private _subscription: Subscription | null = null;
  private _cancel: boolean = false;

  constructor(obj: ICancelAsync) {
    super(obj);
  }

  public get subscription(): Subscription | null {
    return this._subscription;
  }
  public set subscription(value: Subscription | null) {
    this._subscription = value;
  }
  public get cancel(): boolean {
    return this._cancel;
  }
  public set cancel(value: boolean) {
    this._cancel = value;
  }
}
